import get from 'lodash.get';

import * as AlertDetailsActions from '../../../store/alerts/details/alerts.details.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';
import { getFilteredPagingStats } from '../../../services/pagination-service';

import * as Actions from './alerts.grid.actions';

const initialState = {
  alerts: [],
  isLoading: true,
  selectedAlertIds: [],
};

const setGridIsLoading = (isLoading) => {
  return (state) => ({
    ...state,
    isLoading,
  });
};

const getNewStateFromPagingData = (state, newPage, pageSize) => {
  return {
    ...state,
    isLoading: true,
    ...getFilteredPagingStats(newPage, pageSize, state.totalRecords, state.pageSize),
  };
};

const actionHandlerMap = {
  [Actions.GET_ORDER_ALERTS_SHIP_TOGETHER_REQUEST]: setGridIsLoading(true),
  [Actions.GET_ORDER_ALERTS_SHIP_TOGETHER_FAILURE]: setGridIsLoading(false),
  [Actions.ALERT_DISMISSAL_REQUEST]: setGridIsLoading(true),
  [Actions.ALERT_DISMISSAL_FAILURE]: setGridIsLoading(false),
  [Actions.GET_ORDER_ALERTS_SHIP_TOGETHER_SUCCESS]: (state, { pageData }) => {
    return {
      ...state,
      alerts: pageData,
      isLoading: false,
      selectedAlertIds: [],
    };
  },
  [Actions.SET_SELECTED_ALERT_IDS]: (state, { selectedIds }) => {
    return {
      ...state,
      selectedAlertIds: selectedIds,
    };
  },
  [Actions.GET_SHIP_TOGETHER_ORDERS_SUCCESS]: (state, { orders }) => {
    return {
      ...state,
      ordersForShipTogether: orders,
    };
  },
  [AlertDetailsActions.GET_ALERT_DETAILS]: setGridIsLoading(true),
  [AlertDetailsActions.GET_ALERT_DETAILS_SUCCESS]: setGridIsLoading(false),
  [Actions.GET_ORDERS_FOR_SELECTED_ALERTS_REQUEST]: (state) => ({
    ...state,
    isLoadingOrders: true,
  }),
  [Actions.GET_ORDERS_FOR_SELECTED_ALERTS_SUCCESS]: (state, { orders }) => {
    return {
      ...state,
      ordersForSelectedAlerts: orders,
      isLoadingOrders: false,
    };
  },
  [AlertDetailsActions.GET_ALERT_DETAILS_SUCCESS]: (state, { alertDetails }) => ({
    ...state,
    selectedAlertIds: [get(alertDetails, 'alertId')],
    isLoading: false,
  }),
  [Actions.ORDER_ALERTS_GRID_CHANGE_PAGE]: (state, { newPage, pageSize }) => {
    return getNewStateFromPagingData(state, newPage, pageSize);
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './alerts.grid.reducer.metadata';
